import { Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';

export class E5coreUiWorkAttachmentsBaseComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() readonly: boolean ;
  @Input() pagesizes: number[] ;

  ngOnInit(): void {
  }

}
